export default __webpack_public_path__ + "static/media/corner-dry-rose-art.e552c88a.webp";